import { formatDate } from '@src/utils';
import { apiService } from '../ServiceApi';

export const parentService = apiService.injectEndpoints({
  endpoints: (builder) => {
    return {
      getGPSAllParentFiles: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `gpsservice/api/${
              pData.search ? 'gpsDashboardSearch' : 'gpsDashboard'
            }`,
            params: {},
            body: JSON.stringify({
              offset: pData.page,
              limit: pData.pageSize,
              countRequired: !pData?.count,
              ...(pData.search
                ? { customerName: pData.search.toUpperCase() }
                : {
                    userId: pData?.user?.userId || '',
                    userType: pData?.user?.userType || '',
                    userFavourites: !!pData?.favourites,
                  }),
            }),
            overrideExisting: true,
          };
        },
      }),
      getGPSFileDetails: builder.query({
        query: (fileId) => {
          return {
            method: 'GET',
            url: `gpsservice/cdbReports/getFileDetails`,
            params: {
              fileId,
              txnSetId: '0',
            },
            overrideExisting: true,
          };
        },
      }),

      setGPSContinueProcessing: builder.query({
        query: (transSetId) => {
          return {
            method: 'POST',
            url: `gpsservice/continueProcessing`,
            params: { transSetId },
          };
        },
      }),
      getGPSReports: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `gpsservice/gpsViewReports`,
            params: {},
            body: JSON.stringify({
              sbmtGrpId: pData?.sbmtGrpId || '',
              rptType: pData?.reportType || '',
              transSetId: pData?.transSetId || '0',
              transSetProcDt: formatDate(pData?.processingDt || ''),
              transFileId: pData?.fileId || '',
              page: pData.page,
              pageSize: pData.pageSize,
              count: !pData?.count,
              ...(pData.search
                ? {
                    searchField: pData.search.toUpperCase() || '',
                  }
                : {}),
            }),
          };
        },
      }),
      getGpsErrorAnalysisRpt: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `gpsservice/gpsErrorAnalysisRpt`,
            params: {},
            body: JSON.stringify({
              page: '1',
              pageSize: '500',
              rptType: pData?.reportType || '',
              count: !pData?.count,
              transSetProcDt: formatDate(pData?.processingDt || ''),
              transSetId: pData?.transSetId || '0',
              transFileId: pData?.fileId || '',
              sbmtGrpId: pData?.sbmtGrpId || '',
            }),
          };
        },
      }),
      getGPSDetailViewDetails: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: 'gpsservice/detailView',
            params: {},
            body: JSON.stringify({
              transSetId: pData.transSetId,
              firstName: pData.firstName,
              lastName: pData.lastName,
              //empId: pData.empId,
              transFileId: pData.transFileId,
              platform: '10',
              ticRelationshipCode: pData.relationship,
              transId: pData.transId,
              subscriberId: pData.medicareId,
            }),
          };
        },
      }),
      getGPSMonitor: builder.query({
        query: (txnSetId) => {
          return {
            method: 'GET',
            url: `gpsservice/MonitorView`,
            params: {
              txnSetId,
            },
          };
        },
      }),
      getGPSProcStats: builder.query({
        query: (transSetId) => {
          return {
            method: 'POST',
            url: 'gpsservice/processingStatsReport/',
            params: {},
            body: JSON.stringify({
              transSetId, // Shorthand for transSetId: transSetId
            }),
          };
        },
      }),
      getGpsSearchReports: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `gpsservice/gpsSearchReports`,
            params: {},
            body: JSON.stringify({
              sbmtGrpId: pData?.sbmtGrpId || '',
              reportType: pData?.reportType || '',
              transSetId: pData?.transSetId || '0',
              transSetProcDt: formatDate(pData?.processingDt || ''),
              transFileId: pData?.fileId || '',
              page: pData.page,
              pageSize: pData.pageSize,
              lastNameSrch: '',
              famId: '',
              empId: '',
              mdcId: '',
              severityCode: 0,
              errorType: pData?.fieldCode || '',
              fileCode: pData?.fieldCode || '',
              ...(pData.search
                ? {
                    searchField: pData.search.toUpperCase() || '',
                  }
                : {}),
            }),
          };
        },
      }),
      getGpsENWChildReports: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `gpsservice/ENWChildReport`,
            params: {},
            body: {
              sbmtGrpId: pData?.sbmtGrpId || '',
              transSetId: pData?.transSetId || '0',
              transSetProcDt: formatDate(pData?.processingDt || ''),
              transFileId: pData?.fileId || '',
              page: pData.page,
              pageSize: pData.pageSize,
              severityCode: 0,

              errorType: pData?.fieldCode,
              rptType: pData?.reportType,
              errorCode: pData?.errorCode,
              ...(pData.search
                ? {
                    searchField: pData.search.toUpperCase() || '',
                  }
                : {}),
            },
          };
        },
      }),
    };
  },
});

export const {
  useLazyGetGPSAllParentFilesQuery,
  useGetGPSAllParentFilesQuery,
  useGetGPSFileDetailsQuery,
  useLazyGetGPSReportsQuery,
  useLazyGetGpsErrorAnalysisRptQuery,
  useGetGPSReportsQuery,
  useLazyGetGpsENWChildReportsQuery,
  // useGetGPSDetailViewDetailsQuery,
  useLazyGetGPSDetailViewDetailsQuery,
  useGetGPSMonitorQuery,
  useGetGPSProcStatsQuery,
  useLazySetGPSContinueProcessingQuery,
  useLazyGetGpsSearchReportsQuery,
} = parentService;
